import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-1ed461aa.js';
import { m as marginPropTypes } from './spacing-0f39ba4a.js';
import { S as SvgIcon } from './SvgIcon-11e6ad98.js';

function IconPullQuote(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.028 7.39c.173 1.133 1.16 1.94 2.28 1.992-.28 1.015-.96 1.419-1.787 1.653-.08.026-.067.104-.067.104l.133.807s.013.065.12.052c2.854-.312 4.787-2.434 4.427-5.012-.333-1.784-1.76-2.473-3.08-2.291-1.32.208-2.227 1.406-2.027 2.695zm9.107 1.992c-.267 1.015-.973 1.419-1.787 1.653-.08.026-.067.104-.067.104l.12.807s.013.065.12.052c2.867-.312 4.774-2.434 4.44-5.012-.347-1.784-1.787-2.473-3.094-2.291-1.32.208-2.227 1.406-2.014 2.695.173 1.146 1.147 1.953 2.28 1.992z"
  }));
}
IconPullQuote.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconPullQuote.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconPullQuote as default };
